import {createSvgIcon} from '../create-svg-icon';

export const AlignVerticalBottomIcon = createSvgIcon(
  <path d="M22 22H2v-2h20v2zM10 2H7v16h3V2zm7 6h-3v10h3V8z" />
, 'AlignVerticalBottomOutlined');
